export enum EventNames {
  Login = 'login',
  Logout = 'logout',
  Search = 'search',
  AddToCart = 'add_to_cart',
  RemoveFromCart = 'remove_from_cart',
  AddPaymentInfo = 'add_payment_info',
  AddShippingInfo = 'add_shipping_info',
  AddToWishlist = 'add_to_wishlist',
  BeginCheckout = 'begin_checkout',
  Purchase = 'purchase',
  SelectContent = 'select_content',
  SelectItem = 'select_item',
  SelectPromotion = 'select_promotion',
  ViewCart = 'view_cart',
  ViewItem = 'view_item',
  ViewItemList = 'view_item_list',
  ViewPromotion = 'view_promotion',
}
